module.exports = __webpack_public_path__ + "img/medium-circle.41ae7e50.svg";